<template>
  <div>
    <div
      v-if="asAnswer"
      class="d-flex flex-column"
      :class="dirClass"
    >
      <div
        class="alert alert-secondary container-fluid text-center"
        :class="{'alert-dark-secondary': value === option.value, 'p-1': small}"
        v-for="option in options"
        :key="option.value"
      >
        <label
          class="p-0 m-0 form-check"
          type="radio"
        >
          <span
            v-if="option.image"
            class="mr-1"
          >
            <img
              class="img-item-option"
              :src="option.image"
              :alt="option.value"
            />
          </span>
          {{ option.value }}
        </label>
      </div>
      <div
        class="alert alert-secondary container-fluid text-center alert-dark-secondary"
        v-if="valueAlt"
        :class="{'p-1': small}"
      >
        <small class="text-sm-center">{{ $t('phrase.else_namely') }}:</small> <br />
        {{valueAlt}}
      </div>
    </div>
    <div
      v-else
      class="d-flex flex-column"
      :class="dirClass"
    >
      <div
        class="alert alert-secondary container-fluid text-center clickable"
        :class="{'alert-dark-secondary': value === option.value}"
        v-for="(option, index) in options"
        :key="option.value"
        @click="researchItem.answer.value = option.value"
        :id="itemId(index)"
      >
        <input
          class="form-check-input invisible"
          type="radio"
          :value="option.value"
          name="radios-example"
          checked=""
          :id="option.value"
          v-model="researchItem.answer.value"
        />
        <label
          class="p-0 m-0 form-check clickable"
          type="radio"
          :value="option.value"
          :for="option.value"
        >
          <span
            v-if="option.image"
            class="mr-1"
          >
            <img
              class="img-item-option"
              :src="option.image"
              :alt="option.value"
            />
          </span>
          {{ option.value }}
        </label>
      </div>
    </div>
    <div v-if="!asAnswer && researchItem.item.config.allow_other">
      <div
        class="alert alert-secondary container-fluid text-center clickable font-italic"
        :class="{'alert-dark-secondary': otherEnabled}"
        @click="toggleOther"
      >
        {{ $t('phrase.else_namely') }}...
      </div>
      <div
        v-if="otherEnabled"
      >
        <v-text-input
          v-model="researchItem.answer.value_alt"
          id="review-research-value-alt"
          :auto-focus="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { shuffle } from '@/common/utils/arrays';
import TextInput from '@/common/components/inputs/TextInput.vue';
import { GenericItemMixin } from '@/reviewer/mixins';

export default {
  name: 'ItemRadioButtons',
  components: {
    'v-text-input': TextInput,
  },
  mixins: [
    GenericItemMixin,
  ],
  data() {
    return {
      otherEnabled: false,
      options: null,
    };
  },
  methods: {
    getOptions() {
      return this.researchItem.options;
    },
    itemId(index) {
      return this.idPrefix ? `${this.idPrefix}-item-radio-button-option-${index}` : `item-radio-button-option-${index}`;
    },
    toggleOther() {
      this.researchItem.answer.value = null;
      if (this.otherEnabled) {
        this.researchItem.answer.value_alt = null;
      }
      this.otherEnabled = !this.otherEnabled;
    },
  },
  watch: {
    value() {
      if (this.researchItem.answer.value) {
        this.otherEnabled = false;
        this.researchItem.answer.value_alt = null;
        this.$emit('value-changed');
      }
    },
  },
  computed: {
    value() {
      return this.researchItem.answer.value;
    },
    valueAlt() {
      return this.researchItem.answer.value_alt;
    },
    dirClass() {
      if (!this.small) {
        return { 'flex-lg-row': this.researchItem.item.config.direction === 'horizontal' };
      }
      return {};
    },
  },
  created() {
    if (this.valueAlt) {
      this.otherEnabled = true;
    }

    if (this.researchItem.item.config.random) {
      this.options = shuffle(this.getOptions());
    } else {
      this.options = this.getOptions();
    }
  },
};
</script>
